import React, { useCallback, useRef } from 'react'
import { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import { ArrowLeftIcon, ArrowRightIcon } from '@/generic/components/ArrowIcons'

import { INTERNAL_MENU_BREAKPOINTS, INTERNAL_MENU_LINKS } from '../constants'

export const CmsInternalMenu = () => {
  const swiperRef = useRef(null)

  const slidePrev = useCallback(() => {
    swiperRef.current.swiper.slidePrev()
  }, [swiperRef])

  const slideNext = useCallback(() => {
    swiperRef.current.swiper.slideNext()
  }, [swiperRef])

  return (
    <div className='cms-block cms-internal-menu'>
      <div className='container'>
        <Swiper
          onBeforeResize={(swiper) => {
            // https://github.com/nolimits4web/Swiper/issues/2346#issuecomment-346858866
            if (window.innerWidth >= 1200) {
              swiper.slides.css('width', '')
            }
          }}
          ref={swiperRef}
          modules={[Navigation]}
          slidesPerView='auto'
          breakpoints={INTERNAL_MENU_BREAKPOINTS}
          loop
        >
          {INTERNAL_MENU_LINKS.map((link, index) => (
            <SwiperSlide key={index}>
              <a href={link.url} title={link.title} key={index}>{link.text}</a>
            </SwiperSlide>
          ))}
        </Swiper>
        <button className='slider-btn-prev' onClick={slidePrev}>
          <ArrowLeftIcon className='svg-inline--fa' />
        </button>
        <button className='slider-btn-next' onClick={slideNext}>
          <ArrowRightIcon className='svg-inline--fa' />
        </button>
      </div>
    </div>
  )
}

export default CmsInternalMenu
